const React = require("react");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { useDropshippingResource } = require("../hooks/useDropshippingResource");
const { PageHeader, ResourceState } = require("../components/ui");
const h = React.createElement;

const DropshippingApiErrors = () => {
  const { api, t } = useCJDropshipping();
  const resource = useDropshippingResource(() => api.getApiErrors(), [api]);
  const groups = resource.data?.errors || {};
  const entries = [
    ...(groups.connections || []).map((item) => ({ id: item._id, source: t("h_cj_connection", "Connection"), title: item.authType || "CJ", message: item.errorMessage, date: item.updatedAt })),
    ...(groups.products || []).map((item) => ({ id: item._id, source: t("h_cj_product", "Product"), title: item.title, message: item.syncError, date: item.updatedAt })),
    ...(groups.orders || []).map((item) => ({ id: item._id, source: t("h_cj_order", "Order"), title: item.supplierOrderId || String(item.orderId), message: item.errorMessage, date: item.updatedAt })),
  ];
  return h(React.Fragment, null,
    h(PageHeader, { title: t("h_cj_errors_title", "CJ API errors"), description: t("h_cj_errors_desc", "Sanitized connection, product synchronization and order errors.") }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !entries.length, onRetry: resource.reload, t },
      h("div", { className: "cjds-table-wrap" }, h("table", { className: "cjds-table" },
        h("thead", null, h("tr", null, h("th", null, t("h_cj_source", "Source")), h("th", null, t("h_cj_item", "Item")), h("th", null, t("h_cj_error", "Error")), h("th", null, t("h_cj_date", "Date")))),
        h("tbody", null, ...entries.map((entry) => h("tr", { key: `${entry.source}-${entry.id}` }, h("td", null, entry.source), h("td", null, entry.title), h("td", null, entry.message), h("td", null, entry.date ? new Date(entry.date).toLocaleString() : "—"))))
      ))
    )
  );
};
module.exports = { DropshippingApiErrors };
